import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { ConsignmentList } from '@/app/(dashboard)/consignments/_components/ConsignmentList'
import { api } from '@/lib/api'
import { useAsyncData } from '@/src/hooks/useAsyncData'
import { LoadingState } from '@/src/components/LoadingState'
import { ErrorState } from '@/src/components/ErrorState'

export function ConsignmentsPage() {
  const { data: consignments, error, loading, reload } = useAsyncData(() => api.consignments.list(), [])

  if (loading) return <LoadingState label="Loading consignments..." />
  if (error) return <ErrorState error={error} onRetry={reload} />

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Consignments</h1>
          <p className="mt-1 text-muted-foreground">Manage and track import consignments</p>
        </div>
        <Link href="/consignments/new">
          <Button>+ New Consignment</Button>
        </Link>
      </div>

      <ConsignmentList consignments={consignments ?? []} />
    </div>
  )
}
